var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomSparkles = function SvgCustomSparkles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.347 12.436 4.449-1.638 1.638-4.452a1.372 1.372 0 0 1 2.575 0l1.64 4.447 4.453 1.638a1.372 1.372 0 0 1 0 2.576l-4.447 1.648-1.638 4.45a1.373 1.373 0 0 1-2.576 0l-1.638-4.449-4.452-1.638a1.372 1.372 0 0 1 0-2.576l-.004-.006Zm4.93 2.926a1.368 1.368 0 0 1 .813.813l1.638 4.436 1.634-4.44a1.37 1.37 0 0 1 .81-.809l4.436-1.638-4.436-1.638a1.37 1.37 0 0 1-.81-.81L13.724 6.84l-1.638 4.437a1.368 1.368 0 0 1-.813.813l-4.436 1.638 4.44 1.634Zm-.311-10.603a.69.69 0 0 0-.69-.69h-1.38v-1.38a.69.69 0 0 0-1.379 0v1.38h-1.38a.69.69 0 0 0 0 1.38h1.38v1.379a.69.69 0 1 0 1.38 0v-1.38h1.379a.69.69 0 0 0 .69-.69ZM2 8.897a.69.69 0 0 0 .69.69h.69v.689a.69.69 0 1 0 1.379 0v-.69h.69a.69.69 0 0 0 0-1.38h-.69v-.689a.69.69 0 1 0-1.38 0v.69h-.69a.69.69 0 0 0-.689.69Z",
    fill: "currentColor"
  })));
};

export default SvgCustomSparkles;